import { render, staticRenderFns } from "./ClientPaymentHistory.vue?vue&type=template&id=01a70dca&scoped=true&"
import script from "./ClientPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a70dca",
  null
  
)

export default component.exports